'use strict';

var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var ChangeModel$PvpcontrollerWeb = require("../models/ChangeModel.js");
var EditModeChangeLogEntry$PvpcontrollerWeb = require("./EditModeChangeLogEntry.js");

function keyForChange(change) {
  return String(change.netId) + " " + ChangeModel$PvpcontrollerWeb.changeObjectTypeName(change) + " " + ChangeModel$PvpcontrollerWeb.changeValueTypeName(change);
}

function EditModeChangelog(Props) {
  var session = Props.session;
  var changes = Props.changes;
  var simplifiedOpt = Props.simplified;
  var onChangeRemoved = Props.onChangeRemoved;
  var onChangeRemovedFail = Props.onChangeRemovedFail;
  var simplified = simplifiedOpt !== undefined ? simplifiedOpt : false;
  if (changes.length > 0) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, Belt_Array.mapWithIndex(changes, (function (i, change) {
                          var alt = i % 2 === 0;
                          return React.createElement(EditModeChangeLogEntry$PvpcontrollerWeb.make, EditModeChangeLogEntry$PvpcontrollerWeb.makeProps(session, changes, alt, change, simplified, onChangeRemoved, onChangeRemovedFail, keyForChange(change), undefined));
                        }))));
  } else {
    return React.createElement("h3", {
                className: Theme$PvpcontrollerWeb.h3
              }, "Nothing to show");
  }
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6) {
  var tmp = {
    session: prim0,
    changes: prim1,
    onChangeRemoved: prim3,
    onChangeRemovedFail: prim4
  };
  if (prim2 !== undefined) {
    tmp.simplified = Caml_option.valFromOption(prim2);
  }
  if (prim5 !== undefined) {
    tmp.key = prim5;
  }
  return tmp;
}

var make = EditModeChangelog;

exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
